import { useState, useEffect } from "react";
import { client } from "../sanity/client";
import { previewClient } from "../sanity/previewClient";

function getActiveClient() {
  const inIframe = typeof window !== "undefined" && window.self !== window.top;
  if (inIframe && previewClient) return previewClient;
  return client;
}

export function useSanityContent(query, fallbackData) {
  const [data, setData] = useState(fallbackData);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const activeClient = getActiveClient();

    if (!activeClient) {
      setLoading(false);
      return;
    }

    const fetchData = () => {
      activeClient
        .fetch(query)
        .then((result) => {
          if (!cancelled && result) setData({ ...fallbackData, ...result });
        })
        .catch(() => {
          if (!cancelled) setData(fallbackData);
        })
        .finally(() => !cancelled && setLoading(false));
    };

    fetchData();

    // Live-refetch on any change while previewing drafts inside Studio's iframe
    const inIframe = window.self !== window.top;
    let subscription;
    if (inIframe && previewClient) {
      subscription = previewClient
        .listen(query, {}, { visibility: "query" })
        .subscribe(() => fetchData());
    }

    return () => {
      cancelled = true;
      if (subscription) subscription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return { data, loading };
}
